"use client";
import React from "react";
import "@/app/solutionslist.css";
import StartTrialBtn from "../StartTrialBtn";
import Image from "next/image";
import Link from "next/link";
import IndustryComponent from "@/component/SustainabilityAanalytics/IndustryComponent";
import ComprehensiveEsgSustainabilityPerformanceReportingIco from "@/Helper/images/comprehensive_esg_sustainability_performance_reporting.svg";
import MaterialDataBreakdownStrategicClarity from "@/Helper/images/material_data_breakdown_for_strategic_clarity.svg";
import StakeholdeEngagementCsrdAlignmentAnalysisIco from "@/Helper/images/stakeholder_engagement_csrd_alignment_analysis.svg";
import DualMaterialityAssessmentForHolisticStrategyICo from "@/Helper/images/dual_materiality_assessment_for_holistic_strategy.svg";
import GovernanceFrameworkAccountabilityStructuresIco from "@/Helper/images/governance_framework_accountability_structures.svg";
import SustainabilityDataGapAnalysisContinuousMonitoringsIco from "@/Helper/images/sustainability_dataGap_analysisContinuous_monitorings.svg";
import KpiProjectionComplianceGoalSettingIco from "@/Helper/images/kpi_projection_compliance_goal_setting.svg";
import EquityIco from "@/Helper/images/equity.svg";
import EfficiencySustainabilityIco from "@/Helper/images/efficiency_sustainability.svg";
import EthicsIco from "@/Helper/images/ethics.svg";
// Importing images
import casestudy1 from "@/Helper/images/Banner/transforming_hr_analytics_with_power_BI_in_the_it_industry.png";
import casestudy2 from "@/Helper/images/Banner/revolutionizing_reporting_for_textile_manufacturing.png";
import casestudy3 from "@/Helper/images/Banner/supply_chain_analytics_transformation_for_manufacturing_client.png";

const caseStudies = [
  {
    image: casestudy1,
    alt: "Transforming HR Analytics with Power BI in the IT Industry",
    link: "/case-study-details-transforming-hr-analytics-with-power-bi-it-industry",
    title: "Transforming HR Analytics with Power BI in the IT Industry",
    description: "From Manual Excel Reports to Real-Time HR Insights for Proactive Decision-Making",
  },
  {
    image: casestudy2,
    alt: "Revolutionizing Reporting for Textile Manufacturing",
    link: "/case-study-details-revolutionizing-reporting-for-textile-manufacturing",
    title: "Revolutionizing Reporting for Textile Manufacturing",
    description: "Streamlining Reporting and Driving Operational Efficiency in the Textile Industry",
  },
  {
    image: casestudy3,
    alt: "Supply Chain Analytics Transformation for a Manufacturing Client",
    link: "/case-study-details-supply-chain-analytics-transformation-manufacturing-client",
    title: "Supply Chain Analytics Transformation for a Manufacturing Client",
    description: "Enhancing Supply Chain Insights and Efficiency",
  },

];
const SustainabilityAanalytics = () => {
  return (
    <>

      <section className="banner_bg1 sustainability_analytics_bg">
        <div className="container banner_container1">
          <div className="banner_inner">
            <div className="banner_left">
              <h1 className="banner_heading1">Discover. Decide. Deliver.</h1>
              <p className="banner_text1"> Leverage advanced analytics to uncover sustainability insights, drive strategic decisions, and create measurable impact for a sustainable future.</p>
              <div className="banner_btn_container">
                <StartTrialBtn Text={"Get Started Today"} />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="common_solutionssection ">
        <div className="container">
          <div className="common_titbox common_titboxcenter">
            <h3 className="common_hd">The triad of transformation</h3>
            <p className="common_desc">A forward-thinking sustainability framework built on Equity, Efficiency, and Ethics. This model empowers organizations to drive impactful change by ensuring fair practices, maximizing resource efficiency, and adhering to the highest ethical standards—paving the way for a resilient and responsible future.</p>
          </div>
          <div className="sol_bottominner">
            <div className="circle research">
              <div className="content">
                <div className="icon">
                  <Image
                    src={EquityIco}
                    alt="Equity"
                  />
                </div>
                <h2>Equity</h2>
                <p>Focus on fairness and inclusiveness, ensuring equal access to resources, opportunities, and benefits for all stakeholders.</p>
              </div>
              <div className="arrow"></div>
            </div>

            <div className="circle time">
              <div className="content">
                <div class="icon">
                  <Image
                    src={EfficiencySustainabilityIco}
                    alt="Efficiency"
                  /></div>
                <h2>Efficiency</h2>
                <p>Emphasize resource optimization, waste reduction, and effective use of energy to minimize environmental impact.</p>
              </div>
              <div className="arrow"></div>
            </div>

            <div className="circle goal">
              <div className="content">
                <div className="icon">
                  <Image
                    src={EthicsIco}
                    alt="Ethics"
                  />
                </div>
                <h2>Ethics</h2>
                <p>Highlight transparency, accountability, and responsible practices that align with moral principles in business decisions.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="common_solutionssection mid_sec">
        <div className="container">
          <div class="common_titbox common_titboxcenter">
            <h2 class="common_hd">Our capabilities</h2>
            <p class="common_desc">Our Sustainability Analytics suite offers a wide range of analytical tools and reporting capabilities, allowing you to <br />comprehensively assess and enhance your organization’s environmental,
              social, and governance performance:</p>

          </div>
          <div className="solution_capablities">
            <div className="sol_listbx">
              <div className="sol_list">
                <div className="sol_list_imgs">
                  <div className="sol_list_imgslft">
                    <Image
                      src={ComprehensiveEsgSustainabilityPerformanceReportingIco}
                      alt="Comprehensive ESG and sustainability performance reporting"
                    />
                  </div>
                  <h2 className="sol_listhd">Comprehensive ESG and sustainability performance reporting</h2>
                </div>
                <p className="sol_list_desc">
                  Deliver full-spectrum ESG reports that capture environmental, social, and governance metrics aligned with regulatory standards and stakeholder expectations.
                </p>
              </div>
            </div>
            <div className="sol_listbx">
              <div className="sol_list">
                <div className="sol_list_imgs">
                  <div className="sol_list_imgslft">
                    <Image
                      src={MaterialDataBreakdownStrategicClarity}
                      alt="Material data breakdown for strategic clarity"
                    />
                  </div>
                  <h2 className="sol_listhd">Material data breakdown for strategic clarity</h2>
                </div>
                <p className="sol_list_desc">
                  Disaggregate complex sustainability metrics into actionable components, providing stakeholders with a clear view of material information.
                </p>
              </div>
            </div>
            <div className="sol_listbx">
              <div className="sol_list">
                <div className="sol_list_imgs">
                  <div className="sol_list_imgslft">
                    <Image
                      src={StakeholdeEngagementCsrdAlignmentAnalysisIco}
                      alt="Stakeholder engagement and CSRD alignment analysis"
                    />
                  </div>
                  <h2 className="sol_listhd">Stakeholder engagement and CSRD alignment analysis</h2>
                </div>
                <p className="sol_list_desc">
                  Evaluate and prioritize stakeholder needs, ensuring your reporting aligns with the Corporate Sustainability Reporting Directive (CSRD) requirements.
                </p>
              </div>
            </div>
            <div className="sol_listbx">
              <div className="sol_list">
                <div className="sol_list_imgs">
                  <div className="sol_list_imgslft">
                    <Image
                      src={DualMaterialityAssessmentForHolisticStrategyICo}
                      alt="Dual materiality assessment for holistic strategy"
                    />
                  </div>
                  <h2 className="sol_listhd">Dual materiality assessment for holistic strategy</h2>
                </div>
                <p className="sol_list_desc">
                  Conduct assessments that consider financial and environmental/social impacts, supporting a balanced, long-term sustainability strategy.
                </p>
              </div>
            </div>
            <div className="sol_listbx">
              <div className="sol_list">
                <div className="sol_list_imgs">
                  <div className="sol_list_imgslft">
                    <Image
                      src={GovernanceFrameworkAccountabilityStructuresIco}
                      alt="Governance framework and accountability structures"
                    />
                  </div>
                  <h2 className="sol_listhd">Governance framework and accountability structures</h2>
                </div>
                <p className="sol_list_desc">
                  Establish governance processes and reporting frameworks that enhance transparency, accountability, and effective communication.
                </p>
              </div>
            </div>
            <div className="sol_listbx">
              <div className="sol_list">
                <div className="sol_list_imgs">
                  <div className="sol_list_imgslft">
                    <Image
                      src={SustainabilityDataGapAnalysisContinuousMonitoringsIco}
                      alt="Sustainability data gap analysis and continuous monitoring"
                    />
                  </div>
                  <h2 className="sol_listhd">Sustainability data gap analysis and continuous monitoring</h2>
                </div>
                <p className="sol_list_desc">
                  Identify areas lacking sufficient data, establishing robust monitoring to ensure complete and accurate tracking of ESG goals.
                </p>
              </div>
            </div>
            <div className="sol_listbx">
              <div className="sol_list">
                <div className="sol_list_imgs">
                  <div className="sol_list_imgslft">
                    <Image
                      src={KpiProjectionComplianceGoalSettingIco}
                      alt="KPI projection and compliance goal setting"
                    />
                  </div>
                  <h2 className="sol_listhd">KPI projection and compliance goal setting</h2>
                </div>
                <p className="sol_list_desc">
                  Use predictive analytics to forecast KPIs, helping to set achievable sustainability targets that align with compliance benchmarks.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="comm_indusreiessection">
        <div className="container">
          <div className="common_titbox common_titboxcenter">
            <h2 className="common_hd">Your competitive edge</h2>
            <p class="common_desc">Our sustainability analytics solutions provide the tools you need to turn sustainability from a challenge <br /> into a competitive advantage. Here’s how our solutions help you lead in sustainable practices</p>
          </div>
          <div className="indus_chooseinner">

            <div className="indus_chooselist indus_chooselist1">
              <h3 className="indus_hd1">All-in-one reporting</h3>
              <p className="indus_desc1">
                Access comprehensive reports that consolidate sustainability metrics across multiple areas, offering a unified view of your environmental impact.
              </p>
            </div>
            <div className="indus_chooselist indus_chooselist2">
              <h3 className="indus_hd1">Customizable alerts and notifications</h3>
              <p className="indus_desc1">
                Stay informed with alerts that flag potential compliance issues or deviations from sustainability goals, ensuring proactive management.
              </p>
            </div>
            <div className="indus_chooselist indus_chooselist3">
              <h3 className="indus_hd1">Predictive analytics for proactive planning</h3>
              <p className="indus_desc1">
                Use predictive modelling to forecast resource needs and set achievable sustainability targets, helping your business stay ahead of regulatory requirements.
              </p>
            </div>
            <div className="indus_chooselist indus_chooselist4">
              <h3 className="indus_hd1">Self-service dashboards</h3>
              <p className="indus_desc1">
                Empower teams with customizable dashboards, allowing them to monitor sustainability KPIs in real-time and make data-driven adjustments as needed.
              </p>
            </div>
            <div className="indus_chooselist indus_chooselist5">
              <h3 className="indus_hd1">Compliance tracking and audits</h3>
              <p className="indus_desc1">
                ETrack compliance in real-time and generate audit-ready reports to simplify adherence to environmental regulations.
              </p>
            </div>
            <div className="indus_chooselist indus_chooselist6">
              <h3 className="indus_hd1">Benchmarking and goal setting</h3>
              <p className="indus_desc1">
                Measure performance against industry benchmarks and set actionable sustainability goals aligned with global best practices.
              </p>
            </div>

          </div>
        </div>
      </section>
     
      <section className="common_solutionssection casestudy_outer1">
        <div className="container">
          <div className="common_titbox common_titboxcenter">
            <h2 className="common_hd">Case Studies</h2>
            {/* <p className="common_desc">A leading logistics company optimized warehouse efficiency and reduced costs by 25% through<br />
              advanced analytics, enhancing inventory placement, labor scheduling, and order fulfillment.</p> */}
          </div>
          <div className="casestudy_inner1">
  {caseStudies.map((study, index) => (
    <div className="casestudylist1" key={index}>
      <div className="casestudytop">
        <Link href={study.link}>
          <Image
            src={study.image}
            alt={study.alt}
            width={380}
            height={340}
            loading="eager"
          />
        </Link>
      </div>
      <div className="casestudybottom1">
        <p className="case_bl_tihd1">
          <Link href={study.link}>{study.title}</Link>
        </p>
        <p className="case_bl_tidesc1">{study.description}</p>
      </div>
    </div>
  ))}
</div>

        </div>
      </section>

      <section className="industry_bg1">
        <div className="container industry_containerouter1">
          <div className="common_titbox common_titboxcenter"><h2 className="common_hd">Why Choose iKnot?</h2>
          </div>
          <IndustryComponent />
        </div>
      </section>
      <section className="cta_outer supplychaincta_bg">
        <div className="container cta_container">
          <div className="cta_inner">
            <div className="cta_innerout1">
              <div className="cta_left1">
                <h3 className="cta_hd">Ready to drive meaningful change with  sustainability analytics?</h3>
                <p className="cta_desc">
                  Get in touch with our experts to harness sustainability data analytics using BI tools, driving impactful and
                  eco-conscious decisions!
                </p>
                <div className="banner_btn_container">
                  <StartTrialBtn Text={"Get Started"} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default SustainabilityAanalytics;
